import React, {FunctionComponent, useEffect, PropsWithChildren,} from 'react'
import {useDispatch, useSelector} from 'react-redux';
import {appRedirectionUpdated} from '../../App/app';
import {AppDispatch, RootState} from '../../store/store';
import {push} from '@lagunovsky/redux-react-router';
import Loading from "../../pages/Loading/Loading";

interface Props {
}

const ProtectedRoute: FunctionComponent = (props: PropsWithChildren<Props>) => {

  const authenticated = useSelector((state: RootState) => state.app.authentication);

  const dispatch = useDispatch<AppDispatch>()


  useEffect(() => {
    if (authenticated === 'failed') {
      dispatch(appRedirectionUpdated(`${location.pathname}${location.search}`));
      dispatch(push('/sign-out'));
    }
  }, [authenticated]);

  if (authenticated === 'succeeded') return <div>{props.children}</div>;

  return <Loading/>;
}

export default ProtectedRoute;
